<template>
  <b-card>
    <form-render :form.sync="form" :fields="fields" :key="keyFormRender" @send="onAccept" @invalidFormWatch="(data) => isInvalid = data" :checkFormAllTime="true">
      <template #buttonsGroupSlot>
        <div class="d-flex justify-content-end mt-2">
          <b-button variant="warning" type="submit" :disabled="isUploading || isInvalid">
            {{ $t('Cargar Archivo') }}
          </b-button>
        </div>
      </template>
    </form-render>
    <div v-if="!isUploading && Object.keys(progress).length">
      <b-alert show variant="info">
        <span>
          Total cargados exitosamente:
          {{ successCount }} | Total con error:
          {{ errorCount }}
        </span>
      </b-alert>
    </div>
    <div
      v-if="Object.keys(progress).length"
      ref="scrollContainer"
      class="scroll-container"
      @scroll="handleScroll"
    >
      <div
        v-for="(id, index) in visibleProgressIds"
        :key="id"
        class="mb-2 progress-bar--container"
        :ref="index === visibleProgressIds.length - 1 ? 'lastItem' : null"
      >
        <span>{{ id }}</span>
        <b-progress
          max="100"
          height="20px"
          :variant="progress[id] && progress[id].variant || 'default'"
          :animated="progress[id] && progress[id].success === null"
          v-b-tooltip.hover
          :title="progress[id] && progress[id].error || ''"
        >
          <b-progress-bar value="100">
            <span>{{ getProgressStatus(id).message }}</span>
          </b-progress-bar>
        </b-progress>
      </div>
    </div>
  </b-card>
</template>

<script>
import BaseServices from '@/store/services/index'
export default {
  name: 'updateAttachmentsMassive',
  data() {
    return {
      form: {
        delivery_id_array: []
      },
      fields: [],
      keyFormRender: 0,
      isUploading: false,
      progress: {},
      visibleCount: 5,
      isInvalid: true,
      baseService: new BaseServices(this)
    }
  },
  computed: {
    visibleProgressIds() {
      return Object.keys(this.progress).slice(0, this.visibleCount)
    },
    successCount() {
      return Object.values(this.progress).filter(p => p.success === true).length
    },
    errorCount() {
      return Object.values(this.progress).filter(p => p.success === false).length
    }
  },
  watch: {
    isUploading() {
      this.setFields()
    }
  },
  mounted() {
    this.setFields()
  },
  methods: {
    async onAccept() {
      if (!Array.isArray(this.form.delivery_id_array) || !this.form.file) return
      this.isUploading = true
      this.progress = {}
      this.visibleCount = 5

      for (const id of this.form.delivery_id_array) {
        this.$set(this.progress, id, {
          success: null,
          error: null,
          variant: 'default'
        })
        await this.$nextTick()
        this.scrollToLastItem()
        try {
          await this.uploadAttachmentAcceptance(id, this.form.file)
          this.$set(this.progress, id, {
            success: true,
            error: null,
            variant: 'success'
          })
        } catch (e) {
          this.$set(this.progress, id, {
            success: false,
            error: e.message || 'Error al subir archivo',
            variant: 'danger'
          })
        }

        await this.$nextTick()
        this.scrollToLastItem()
      }
      this.isUploading = false
    },
    async uploadAttachmentAcceptance(id, file) {
      return new Promise((resolve, reject) => {
        const formSend = {
          'attachment_type_code': 'COURIER_ACCEPTANCE',
          'confirm_summary': true,
          'send_message': 1,
          'delivery_id': id
        }
        this.baseService.callSpecialUploadFile('updateFiles', file, { id, ticket_id: id }, this.$session.get('cas_user'), formSend, 'files')
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    getProgressStatus(id) {
      const status = this.progress[id]
      if (!status) return { variant: 'default', message: 'Subiendo archivo...' }
      if (status.error) return { variant: 'danger', message: 'Error al subir el archivo' }
      if (status.success) return { variant: 'success', message: 'Archivo subido exitosamente' }
      return { variant: 'default', message: 'Subiendo archivo...' }
    },
    scrollToLastItem() {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer
        const lastItem = this.$refs.lastItem
        if (container && lastItem && lastItem[0]) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
    handleScroll(e) {
      const container = e.target
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10) {
        if (this.visibleCount < Object.keys(this.progress).length) {
          this.visibleCount += 5
        }
      }
    },
    setFields() {
      this.fields = [
        { fieldType: 'FieldInput', name: 'type_file', label: 'Tipo de archivo', containerClass: 'col-12 container-info', disabled: true, placeholder: 'Aceptación courier'},
        { fieldType: 'FieldFile', name: 'file', label: 'Adjuntar Archivo Aceptación Courier', containerClass: 'col-12 container-info', validation: 'required', disabled: this.isUploading },
        {
          fieldType: 'FieldTags',
          label: 'OTs / IDs',
          name: 'delivery_id_array',
          placeholder: 'Ingrese o pegue las OTs/IDs...',
          popoverData: {
            title: 'Ingrese o pegue las OTs / IDs de los envíos asociados al respaldo, separados por una coma o un enter.',
            variant: 'danger'
          },
          idTagReference: 'deliveryIdArrayPopover',
          tagsOption: {
            limitTagsText: this.$t('Limite de OT alcanzadas'),
            duplicateTagText: this.$t('Orden de transporte duplicada'),
            limit: 100
          },
          validation: 'required',
          containerClass: 'col-12 container-info',
          disabled: this.isUploading
        },
        { name: 'buttonsGroupSlot', useSlot: true, containerClass: 'col-12 container-info' }
      ]
    }
  }
}
</script>

<style lang="scss">
.progress-bar--container {
  display: grid;
  grid-template-columns: 200px 1fr auto;
  gap: 10px;
}
.scroll-container {
  max-height: 350px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
}
</style>
